// Schrittanzeige für mehrstufige Formulare (Prototyp CSV-Import): Kreis mit Nummer/Haken, Text, Linie.
// Schmal (< 600 px) steht nur der aktive Schritt mit Text da.
import { Fragment } from 'react';
import { Check } from '@phosphor-icons/react';
import { useViewport } from '../hooks';
import { ABSCHNITT, SCHRITT } from './form-stil';

export function FormSchritte({ schritte, aktiv }: { schritte: readonly string[]; aktiv: number }) {
  const { width } = useViewport();
  const schmal = width < 600;
  return (
    <ol aria-label="Schritte" className="pf-rise m-0 flex shrink-0 list-none items-center" style={{
      gap: 8, padding: '14px 16px', borderRadius: ABSCHNITT.radius, boxShadow: ABSCHNITT.schatten,
      background: 'linear-gradient(165deg,rgba(95,211,138,0.12),rgba(255,255,255,0.035) 55%,rgba(255,255,255,0.02))',
    }}>
      {schritte.map((l, i) => {
        const n = i + 1;
        const z = n < aktiv ? SCHRITT.fertig : n === aktiv ? SCHRITT.aktiv : SCHRITT.offen;
        return (
          <Fragment key={l}>
            <li aria-current={n === aktiv ? 'step' : undefined} className="flex min-w-0 shrink-0 items-center" style={{ gap: 8 }}>
              <span className="flex shrink-0 items-center justify-center rounded-full" style={{
                width: 30, height: 30, fontSize: 13, fontWeight: 800, background: z.flaeche, color: z.text, boxShadow: z.schatten,
                transition: 'all .35s cubic-bezier(.2,.9,.25,1.15)',
              }}>
                {n < aktiv ? <Check aria-hidden size={14} weight="bold" /> : n}
              </span>
              <span className={schmal && n !== aktiv ? 'sr-only' : 'whitespace-nowrap'} style={{ fontSize: 12.5, fontWeight: 800, color: z.label }}>{l}</span>
            </li>
            {n < schritte.length && (
              <li aria-hidden className="flex-1" style={{ minWidth: 10, height: 2, borderRadius: 2, background: n < aktiv ? SCHRITT.linieFertig : SCHRITT.linieOffen, transition: 'background .35s' }} />
            )}
          </Fragment>
        );
      })}
    </ol>
  );
}
